/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import { IssueCommonErrorBoundary } from '@jira/issue__commmon-error-boundary/src/IssueCommonErrorBoundary.tsx';
import type { ExtraErrorAttributes } from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';
import type { AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge/src/types.tsx';
import {
	fireOperationalAnalyticsDeferred,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import type { JiraIssueCreateErrorBoundaryProps } from './types.tsx';

export const JiraIssueCreateErrorBoundary = (
	props: JiraIssueCreateErrorBoundaryProps,
): React.JSX.Element => {
	const { children, attributes, onError, taskName, ...otherProps } = props;
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const getAttributes = useCallback(
		(error: Error): AnalyticsAttributes => {
			// TODO: add additional attributes in that we need for issue create.
			const attributesPassed = typeof attributes === 'function' ? attributes(error) : attributes;
			return {
				...attributesPassed,
			};
		},
		[attributes],
	);

	const handleOnError = useCallback(
		(location: string, error: Error, errorAttributes: ExtraErrorAttributes) => {
			if (taskName) {
				const analyticsEvent = createAnalyticsEvent({});
				fireOperationalAnalyticsDeferred(analyticsEvent, 'ui taskFail', {
					task: taskName,
				});
			}

			onError?.(location, error, errorAttributes);
		},
		[createAnalyticsEvent, onError, taskName],
	);

	return (
		<IssueCommonErrorBoundary {...otherProps} attributes={getAttributes} onError={handleOnError}>
			{children}
		</IssueCommonErrorBoundary>
	);
};
